import { graphql } from '@api/generated';

export const GET_ABANDONED_CALL_FOLLOW_UPS_QUERY = graphql(`
  query abandonedCalls(
    $filter: AbandonedCallFollowUpFilterInput
    $skip: Int
    $take: Int
    $order: AbandonedCallFollowUpSortInput
  ) {
    abandonedCallFollowUps(
      filter: $filter
      skip: $skip
      take: $take
      order: $order
    ) {
      items {
        followUpId
        abandonedCallId
        contactCenterId
        tenant {
          id
          name
        }
        followUpStatus
        queue {
          id
          name
        }
        contactInfo {
          phoneNumber
        }
        customer {
          id
          name
        }
        campaign {
          id
          name
        }
        followUpCreatedAt
        followUpUpdatedAt
        abandonedCallCreatedAt
        abandonedCallUpdatedAt
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`);

export const DISMISS_ABANDONED_CALL_FOLLOW_UP_MUTATION = graphql(`
  mutation UpdateFollowUpDismiss(
    $followUpId: ID!
    $input: FollowUpDismissInput!
  ) {
    updateFollowUpDismiss(followUpId: $followUpId, input: $input) {
      archivedAt
      contactCenterId
      createdAt
      customerId
      dismissReasonId
      followUpType
      id
      status
      tenantId
      to
      updatedAt
    }
  }
`);

// TODO: Move to a different file, as it's not specific to abandoned calls
export const UPDATE_FOLLOW_UP_MUTATION = graphql(`
  mutation updateFollowUp($followUpId: ID!, $input: FollowUpUpdateInput!) {
    updateFollowUp(followUpId: $followUpId, input: $input) {
      archivedAt
      assignment {
        assignedAt
        assignedToId
      }
      contactCenterId
      customerId
      dismissReasonId
      followUpType
      id
      metaData {
        key
        value
      }
      status
      tenantId
      to
      createdAt
      updatedAt
    }
  }
`);
